/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * PromptJsonKeyApi - axios parameter creator
 * @export
 */
export const PromptJsonKeyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * AIフィードバックプロンプトのJSONキー一覧取得API
         * @summary AIフィードバックプロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiFeedbackPromptJsonKeys: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_json_keys/ai_feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 商談獲得判断プロンプトのJSONキー一覧取得API
         * @summary 商談獲得判断プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealAcquiredJudgmentPromptJsonKeys: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_json_keys/deal_acquired_judgment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 追客判定用要否判断プロンプトのJSONキー一覧取得API
         * @summary 追客判定用要否判断プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpNecessityJudgmentPromptJsonKeys: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_json_keys/follow_up_necessity_judgment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 追客判定用ヒアリング項目抽出プロンプトのJSONキー一覧取得API
         * @summary 追客判定用ヒアリング項目抽出プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHearingItemExtractionPromptJsonKeys: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_json_keys/hearing_item_extraction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 次のアクション情報抽出プロンプトのJSONキー一覧取得API
         * @summary 次のアクション情報抽出プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextActionSuggestionExtractionPromptJsonKeys: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_json_keys/next_action_suggestion_extraction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 定性評価フィードバックプロンプトのJSONキー一覧取得API
         * @summary 定性評価フィードバックプロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQualitativeFeedbackPromptJsonKeys: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_json_keys/qualitative_feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 発話者判定プロンプトのJSONキー一覧取得API
         * @summary 発話者判定プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpeakerIdentificationPromptJsonKeys: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_json_keys/speaker_identification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 時系列プロンプトのJSONキー一覧取得API
         * @summary 時系列プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimelinePromptJsonKeys: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_json_keys/timeline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 留守電判定プロンプトのJSONキー一覧取得API
         * @summary 留守電判定プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoicemailJudgmentPromptJsonKeys: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_json_keys/voicemail_judgment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromptJsonKeyApi - functional programming interface
 * @export
 */
export const PromptJsonKeyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromptJsonKeyApiAxiosParamCreator(configuration)
    return {
        /**
         * AIフィードバックプロンプトのJSONキー一覧取得API
         * @summary AIフィードバックプロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAiFeedbackPromptJsonKeys(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAiFeedbackPromptJsonKeys(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 商談獲得判断プロンプトのJSONキー一覧取得API
         * @summary 商談獲得判断プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDealAcquiredJudgmentPromptJsonKeys(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDealAcquiredJudgmentPromptJsonKeys(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 追客判定用要否判断プロンプトのJSONキー一覧取得API
         * @summary 追客判定用要否判断プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFollowUpNecessityJudgmentPromptJsonKeys(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFollowUpNecessityJudgmentPromptJsonKeys(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 追客判定用ヒアリング項目抽出プロンプトのJSONキー一覧取得API
         * @summary 追客判定用ヒアリング項目抽出プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHearingItemExtractionPromptJsonKeys(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHearingItemExtractionPromptJsonKeys(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 次のアクション情報抽出プロンプトのJSONキー一覧取得API
         * @summary 次のアクション情報抽出プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextActionSuggestionExtractionPromptJsonKeys(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextActionSuggestionExtractionPromptJsonKeys(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 定性評価フィードバックプロンプトのJSONキー一覧取得API
         * @summary 定性評価フィードバックプロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQualitativeFeedbackPromptJsonKeys(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQualitativeFeedbackPromptJsonKeys(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 発話者判定プロンプトのJSONキー一覧取得API
         * @summary 発話者判定プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpeakerIdentificationPromptJsonKeys(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpeakerIdentificationPromptJsonKeys(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 時系列プロンプトのJSONキー一覧取得API
         * @summary 時系列プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimelinePromptJsonKeys(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimelinePromptJsonKeys(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 留守電判定プロンプトのJSONキー一覧取得API
         * @summary 留守電判定プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoicemailJudgmentPromptJsonKeys(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoicemailJudgmentPromptJsonKeys(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PromptJsonKeyApi - factory interface
 * @export
 */
export const PromptJsonKeyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromptJsonKeyApiFp(configuration)
    return {
        /**
         * AIフィードバックプロンプトのJSONキー一覧取得API
         * @summary AIフィードバックプロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiFeedbackPromptJsonKeys(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAiFeedbackPromptJsonKeys(options).then((request) => request(axios, basePath));
        },
        /**
         * 商談獲得判断プロンプトのJSONキー一覧取得API
         * @summary 商談獲得判断プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealAcquiredJudgmentPromptJsonKeys(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getDealAcquiredJudgmentPromptJsonKeys(options).then((request) => request(axios, basePath));
        },
        /**
         * 追客判定用要否判断プロンプトのJSONキー一覧取得API
         * @summary 追客判定用要否判断プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpNecessityJudgmentPromptJsonKeys(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getFollowUpNecessityJudgmentPromptJsonKeys(options).then((request) => request(axios, basePath));
        },
        /**
         * 追客判定用ヒアリング項目抽出プロンプトのJSONキー一覧取得API
         * @summary 追客判定用ヒアリング項目抽出プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHearingItemExtractionPromptJsonKeys(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getHearingItemExtractionPromptJsonKeys(options).then((request) => request(axios, basePath));
        },
        /**
         * 次のアクション情報抽出プロンプトのJSONキー一覧取得API
         * @summary 次のアクション情報抽出プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextActionSuggestionExtractionPromptJsonKeys(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getNextActionSuggestionExtractionPromptJsonKeys(options).then((request) => request(axios, basePath));
        },
        /**
         * 定性評価フィードバックプロンプトのJSONキー一覧取得API
         * @summary 定性評価フィードバックプロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQualitativeFeedbackPromptJsonKeys(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getQualitativeFeedbackPromptJsonKeys(options).then((request) => request(axios, basePath));
        },
        /**
         * 発話者判定プロンプトのJSONキー一覧取得API
         * @summary 発話者判定プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpeakerIdentificationPromptJsonKeys(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getSpeakerIdentificationPromptJsonKeys(options).then((request) => request(axios, basePath));
        },
        /**
         * 時系列プロンプトのJSONキー一覧取得API
         * @summary 時系列プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimelinePromptJsonKeys(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getTimelinePromptJsonKeys(options).then((request) => request(axios, basePath));
        },
        /**
         * 留守電判定プロンプトのJSONキー一覧取得API
         * @summary 留守電判定プロンプトのJSONキー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoicemailJudgmentPromptJsonKeys(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getVoicemailJudgmentPromptJsonKeys(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PromptJsonKeyApi - interface
 * @export
 * @interface PromptJsonKeyApi
 */
export interface PromptJsonKeyApiInterface {
    /**
     * AIフィードバックプロンプトのJSONキー一覧取得API
     * @summary AIフィードバックプロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApiInterface
     */
    getAiFeedbackPromptJsonKeys(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 商談獲得判断プロンプトのJSONキー一覧取得API
     * @summary 商談獲得判断プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApiInterface
     */
    getDealAcquiredJudgmentPromptJsonKeys(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 追客判定用要否判断プロンプトのJSONキー一覧取得API
     * @summary 追客判定用要否判断プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApiInterface
     */
    getFollowUpNecessityJudgmentPromptJsonKeys(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 追客判定用ヒアリング項目抽出プロンプトのJSONキー一覧取得API
     * @summary 追客判定用ヒアリング項目抽出プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApiInterface
     */
    getHearingItemExtractionPromptJsonKeys(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 次のアクション情報抽出プロンプトのJSONキー一覧取得API
     * @summary 次のアクション情報抽出プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApiInterface
     */
    getNextActionSuggestionExtractionPromptJsonKeys(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 定性評価フィードバックプロンプトのJSONキー一覧取得API
     * @summary 定性評価フィードバックプロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApiInterface
     */
    getQualitativeFeedbackPromptJsonKeys(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 発話者判定プロンプトのJSONキー一覧取得API
     * @summary 発話者判定プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApiInterface
     */
    getSpeakerIdentificationPromptJsonKeys(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 時系列プロンプトのJSONキー一覧取得API
     * @summary 時系列プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApiInterface
     */
    getTimelinePromptJsonKeys(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 留守電判定プロンプトのJSONキー一覧取得API
     * @summary 留守電判定プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApiInterface
     */
    getVoicemailJudgmentPromptJsonKeys(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

}

/**
 * PromptJsonKeyApi - object-oriented interface
 * @export
 * @class PromptJsonKeyApi
 * @extends {BaseAPI}
 */
export class PromptJsonKeyApi extends BaseAPI implements PromptJsonKeyApiInterface {
    /**
     * AIフィードバックプロンプトのJSONキー一覧取得API
     * @summary AIフィードバックプロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApi
     */
    public getAiFeedbackPromptJsonKeys(options?: AxiosRequestConfig) {
        return PromptJsonKeyApiFp(this.configuration).getAiFeedbackPromptJsonKeys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 商談獲得判断プロンプトのJSONキー一覧取得API
     * @summary 商談獲得判断プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApi
     */
    public getDealAcquiredJudgmentPromptJsonKeys(options?: AxiosRequestConfig) {
        return PromptJsonKeyApiFp(this.configuration).getDealAcquiredJudgmentPromptJsonKeys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 追客判定用要否判断プロンプトのJSONキー一覧取得API
     * @summary 追客判定用要否判断プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApi
     */
    public getFollowUpNecessityJudgmentPromptJsonKeys(options?: AxiosRequestConfig) {
        return PromptJsonKeyApiFp(this.configuration).getFollowUpNecessityJudgmentPromptJsonKeys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 追客判定用ヒアリング項目抽出プロンプトのJSONキー一覧取得API
     * @summary 追客判定用ヒアリング項目抽出プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApi
     */
    public getHearingItemExtractionPromptJsonKeys(options?: AxiosRequestConfig) {
        return PromptJsonKeyApiFp(this.configuration).getHearingItemExtractionPromptJsonKeys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 次のアクション情報抽出プロンプトのJSONキー一覧取得API
     * @summary 次のアクション情報抽出プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApi
     */
    public getNextActionSuggestionExtractionPromptJsonKeys(options?: AxiosRequestConfig) {
        return PromptJsonKeyApiFp(this.configuration).getNextActionSuggestionExtractionPromptJsonKeys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 定性評価フィードバックプロンプトのJSONキー一覧取得API
     * @summary 定性評価フィードバックプロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApi
     */
    public getQualitativeFeedbackPromptJsonKeys(options?: AxiosRequestConfig) {
        return PromptJsonKeyApiFp(this.configuration).getQualitativeFeedbackPromptJsonKeys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 発話者判定プロンプトのJSONキー一覧取得API
     * @summary 発話者判定プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApi
     */
    public getSpeakerIdentificationPromptJsonKeys(options?: AxiosRequestConfig) {
        return PromptJsonKeyApiFp(this.configuration).getSpeakerIdentificationPromptJsonKeys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 時系列プロンプトのJSONキー一覧取得API
     * @summary 時系列プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApi
     */
    public getTimelinePromptJsonKeys(options?: AxiosRequestConfig) {
        return PromptJsonKeyApiFp(this.configuration).getTimelinePromptJsonKeys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 留守電判定プロンプトのJSONキー一覧取得API
     * @summary 留守電判定プロンプトのJSONキー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptJsonKeyApi
     */
    public getVoicemailJudgmentPromptJsonKeys(options?: AxiosRequestConfig) {
        return PromptJsonKeyApiFp(this.configuration).getVoicemailJudgmentPromptJsonKeys(options).then((request) => request(this.axios, this.basePath));
    }
}
